import {$lang} from '@/views/settings/team/lang'

export const HOTKEY_INVOICE_ASSIGN = 'HOTKEY_INVOICE_ASSIGN'
export const HOTKEY_INVOICE_SET_LOCATION = 'HOTKEY_INVOICE_SET_LOCATION'
export const HOTKEY_INVOICE_SUBSIDIARY = 'HOTKEY_INVOICE_SUBSIDIARY'
export const HOTKEY_INVOICE_NEXT = 'HOTKEY_INVOICE_NEXT'
export const HOTKEY_INVOICE_PREV = 'HOTKEY_INVOICE_PREV'
export const HOTKEY_INVOICE_REPORT = 'HOTKEY_INVOICE_REPORT'

export const HOTKEY_INVOICE_SET_STATUS = 'HOTKEY_INVOICE_SET_STATUS'
export const HOTKEY_INVOICE_SET_STATUS_READY = 'HOTKEY_INVOICE_SET_STATUS_READY'
export const HOTKEY_INVOICE_SET_STATUS_REVIEW = 'HOTKEY_INVOICE_SET_STATUS_REVIEW'
export const HOTKEY_INVOICE_SET_STATUS_COMPLETE = 'HOTKEY_INVOICE_SET_STATUS_COMPLETE'

export const HOTKEY_INVOICE_COMPLETE = 'HOTKEY_INVOICE_COMPLETE'
export const HOTKEY_INVOICE_MAP = 'HOTKEY_INVOICE_MAP'

export const documentViewerHotkeys = Object.freeze({
    assign: {
        key: HOTKEY_INVOICE_ASSIGN,
        title: 'Assign',
        description: 'Assign member',
        hotkey: 'D+A'
    },
    location: {
        key: HOTKEY_INVOICE_SET_LOCATION,
        title: $lang.location.singular,
        description: `Set ${$lang.location.singular}`,
        hotkey: 'D+L'
    },
    subsidiary: {
        key: HOTKEY_INVOICE_SUBSIDIARY,
        title: $lang.subsidiary.singular,
        description: `Set ${$lang.subsidiary.singular}`,
        hotkey: 'D+B'
    },
    next: {
        key: HOTKEY_INVOICE_NEXT,
        title: 'Next',
        description: 'Next invoice',
        hotkey: 'D+K'
    },
    previous: {
        key: HOTKEY_INVOICE_PREV,
        title: 'Previous',
        description: 'Previous invoice',
        hotkey: 'D+J'
    },
    report: {
        key: HOTKEY_INVOICE_REPORT,
        title: 'Report',
        description: 'Report a problem',
        hotkey: 'D+Z'
    },
    status: {
        key: HOTKEY_INVOICE_SET_STATUS,
        title: 'Status',
        description: 'Set status',
        hotkey: 'D+S'
    },
    map: {
        key: HOTKEY_INVOICE_MAP,
        title: 'Open AI Assistant',
        description: 'Map Document with AI Assistant',
        hotkey: 'D+I'
    },
    complete: {
        key: HOTKEY_INVOICE_COMPLETE,
        title: 'Complete',
        description: 'Complete invoice',
        hotkey: 'Ctrl+Enter'
    }
})
